import { ItemPickerOptionModel } from './item-picker-option.model';
import { ItemPickerSettingsModel } from './item-picker-settings.model';

export class ItemPickerModel {
	public isLoading: boolean;
	public options: ItemPickerOptionModel[] | null;
	public settings: ItemPickerSettingsModel;

	public constructor(params: Partial<ItemPickerModel>) {
		this.isLoading = params.isLoading;
		this.options = params.options;
		this.settings = params.settings;
	}

	public updateIsLoading(isLoading: boolean): void {
		this.isLoading = isLoading;
	}

	public updateOptions(items: ItemPickerOptionModel[]): void {
		this.options = items;
	}

	public selectItem(value: string): void {
		if (!this.settings.allowMultiSelection) {
			this.options.forEach((item: ItemPickerOptionModel) => {
				item.isSelected = false;
			});
		}

		const itemToSelect: ItemPickerOptionModel | undefined = this.options.find(
			(item: ItemPickerOptionModel) => item.value === value
		);

		if (itemToSelect) {
			itemToSelect.isSelected = true;
		}
	}
}
